import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../../services/auth';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import socket from '../../../utils/socket'; // Use a instância única do socket

const Chat = ({ match }) => {
  const [chat, setChat] = useState([]);
  const { user, token } = isAuthenticated();

  useEffect(() => {
    if (user && !socket.connected) {
      socket.connect();
      socket.emit('join', { userId: user._id });
    }

    socket.emit('helloWorld', { name: 'Donald', age: 28 });

    socket.on('dataReceived', ({ msg }) => {
      console.log(msg);
    });

    // Limpeza dos listeners ao desmontar
    return () => {
      socket.off('dataReceived');
    };
  }, [user]);

  return (
    <>
      <div className='row container-fluid mx-auto mt-5 profile-container'>
        <div className='col-md-7 mx-auto mb-5'>
          <div className='card rounded-0 profile-card card-shadow'>
            <div className='d-flex justify-content-between card-header profile-card p-3' style={{ alignItems: 'center' }}>
              <h2 className='text-center d-flex align-items-center' style={{ margin: 0, fontSize: 24 }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <Link
                    to={`/user/messages?&message=${match.params.chatId}`}
                    className='text-decoration-none text-dark1 pe-4'
                  >
                    <Tooltip title='Voltar para Mensagens'>
                      <span className='category-span' style={{ display: 'inline-flex', alignItems: 'center', marginRight: 20 }}>
                        <i className='fas fa-arrow-circle-left p-0' style={{ fontSize: 28 }}></i>
                      </span>
                    </Tooltip>
                  </Link>
                </span>
                <span style={{ marginLeft: 18, fontWeight: 600, fontSize: 22, display: 'inline-block' }}>Chat com</span>
              </h2>
            </div>
            {/* {chats.length > 0 && <ChatList chats={chats} />} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Chat;
